let upsellSwiper;

function initUpsellSwiper() {
    const slider = document.querySelector('.upsell_products-slider');

    if (!slider || slider.swiper) return;

    upsellSwiper = new Swiper(slider, {
        slidesPerView: 3.2,
        spaceBetween: 5,
        grabCursor: true,

        mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
        },
        /*breakpoints: {
        // Mobile
        0: {
            slidesPerView: 1.5,
            spaceBetween: 10,
        },

        // Large mobile
        480: {
            slidesPerView: 1.5,
            spaceBetween: 12,
        },

        // Tablet
        768: {
            slidesPerView: 3.2,
            spaceBetween: 16,
        },

        // Desktop
        1024: {
            slidesPerView: 3.2,
            spaceBetween: 20,
        },

        // Large desktop
        1440: {
            slidesPerView: 3.2,
            spaceBetween: 24,
        }
      }*/
    });

    console.log('Swiper initialized');
}
const observer = new MutationObserver(() => { 
  initUpsellSwiper(); 
}); 
observer.observe(document.querySelector('cart-drawer-component'), { childList: true, subtree: true });
initUpsellSwiper();

/*
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.upselladdtocart');
  if (!btn) return;

  e.preventDefault();
   

  try {
    const formData = new FormData();
    formData.append('id', btn.dataset.variantId);
    formData.append('quantity', 1);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error('Failed to add item');
    }

    const item = await response.json();

    // Script for record GA4 custom event
    if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish('cart_upsell_add', {
            product_id: item.product_id,
            variant_id: item.variant_id,
            product_title: item.title,
            quantity: item.quantity,
            price: item.price,
            currency: Shopify.currency.active
        });
    }

    // Get updated cart
    const cart = await fetch('/cart.js').then(r => r.json());
    // Notify the theme
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            itemCount: cart.item_count
          }
        }
      })
    );

  } catch (err) {
    console.error(err);
  }
});

*/